import * as Mailcheck from "mailcheck";

var emailCheck = function() {
    let domains = ['gmail.com',
        'live.fr',
        'yahoo.fr',
        'orange.fr',
        'sfr.fr',
        'wanadoo.fr',
        'bouyguestelecom.fr',
        'laposte.net'
    ]
    let secondLevelDomains = ['outlook', 'hotmail', 'icloud']
    let topLevelDomains = ["com", "net", "fr"];

    let mailSuggestion = document.getElementById("mail-suggestion-js");
    if (mailSuggestion) {
        let spanText = mailSuggestion.getElementsByTagName('a')[0]

        $("#email-input-js").bind("change", function() {
            Mailcheck.run({
                email: this.value,
                domains: domains,
                secondLevelDomains: secondLevelDomains,
                topLevelDomains: topLevelDomains,
                suggested: function (suggestion) {
                    mailSuggestion.style.display = 'block';
                    spanText.textContent = suggestion.full
                },
                empty: function () {
                    mailSuggestion.style.display = 'none';
                }
            });
        })
    }
}

var changeEmail = function () {
    $('#mail-suggestion-js a').click(function(){
        document.getElementById('email-input-js').value = $(this).text();
        document.getElementById("mail-suggestion-js").style.display = 'none';
    });
}

$(document).ready(function() {
    emailCheck();
    changeEmail();
})